export default __webpack_public_path__ + "static/media/Franklin-Gothic-Medium-Cond-Regular.c1b1d9d1.ttf";